import { cn } from '@/lib/cn';

type SubtitleProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};

export const Subtitle = ({ children, className, id }: SubtitleProps) => {
  return (
    <p id={id} className={cn('text-content-subtitle text-sm', className)}>
      {children}
    </p>
  );
};
